import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import { useEmailStatisticsPool } from 'modules/email-statistics/hooks/use-email-statistics-pool';
import { MailingPoolStatusColors, MailingPoolStatusHelpMessages, MailingPoolStatusTitles } from 'shared/components/dashboard-mail-editor/enums/mailing-pool-status-enum';
import { getEmailStatusLink } from 'shared/components/dashboard-mail-editor/utils/get-email-status-link';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
const EmailStatisticsPool = () => {
  const $ = _c(27);
  const {
    user
  } = useUser();
  const {
    data: poolData
  } = useEmailStatisticsPool();
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.email_statistics.pool");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `${t0}:`;
  let t2;
  if ($[2] !== t1) {
    t2 = <span>{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== poolData || $[5] !== t || $[6] !== user?.dashboardLocale) {
    t3 = poolData ? <Hint color={MailingPoolStatusColors[poolData.mailingPool]} label={<TransLoco t={t} i18nKey={MailingPoolStatusHelpMessages[poolData.mailingPool]} components={{
      a: <a href={getEmailStatusLink(user?.dashboardLocale)} target="_blank" rel="noreferrer" className="primary-link" />
    }} />}><span>{t(MailingPoolStatusTitles[poolData.mailingPool])}</span></Hint> : <span className="bg-skeleton-primary animate-pulse rounded-lg px-5 text-transparent">.</span>;
    $[4] = poolData;
    $[5] = t;
    $[6] = user?.dashboardLocale;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="text-text-primary flex gap-1 text-[17px] font-bold">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("dashboard.email_statistics.since");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = `${t5}:`;
  let t7;
  if ($[13] !== t6) {
    t7 = <span>{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== poolData || $[16] !== t || $[17] !== user?.dateFormat || $[18] !== user?.timeFormat || $[19] !== user?.timezone) {
    t8 = poolData ? poolData.updateDetails ? <Hint label={<div className="flex flex-col gap-3"><p className="text-start">{`${t("dashboard.email_statistics.from_pool")}: ${t(MailingPoolStatusTitles[poolData.updateDetails.fromPool])}`}</p>{poolData.updateDetails.fromDate && poolData.updateDetails.toDate && <p className="text-start">{t("dashboard.email_statistics.update_reason_period", {
          dateSince: dateTimeFormat(poolData.updateDetails.fromDate, {
            timeZone: user?.timezone,
            dateFormat: user?.dateFormat,
            timeFormat: user?.timeFormat
          }),
          dateTill: dateTimeFormat(poolData.updateDetails.toDate, {
            timeZone: user?.timezone,
            dateFormat: user?.dateFormat,
            timeFormat: user?.timeFormat
          })
        })}</p>}</div>}>{dateTimeFormat(poolData.mailingPoolUpdatedAt, {
        timeZone: user?.timezone,
        dateFormat: user?.dateFormat,
        timeFormat: user?.timeFormat
      })}</Hint> : <span>{dateTimeFormat(poolData.mailingPoolUpdatedAt, {
        timeZone: user?.timezone,
        dateFormat: user?.dateFormat,
        timeFormat: user?.timeFormat
      })}</span> : <span className="bg-skeleton-primary animate-pulse rounded-lg px-5 text-transparent">.</span>;
    $[15] = poolData;
    $[16] = t;
    $[17] = user?.dateFormat;
    $[18] = user?.timeFormat;
    $[19] = user?.timezone;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="text-text-primary flex gap-1 text-[17px]">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t9) {
    t10 = <div className="flex w-full flex-col gap-1.5">{t4}{t9}</div>;
    $[24] = t4;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default EmailStatisticsPool;